/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-14 12:21:22
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-18 17:14:00
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/ProductDetail/Components/FieldPart/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { TextArea, NumberInput } from '@/src/components/Antd';
import SectionContent from 'src/pages/ProductEditor/VirtualProduct/ProductDetail/Components/SectionWrapper';
import Row from '@/src/components/Layouts/Row/Row';
import CountWords from '@/src/components/CountWords/CountWords';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Field = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    onCharLimitChange,

    onPlaceholderChange,
    disabled,
  } = props;
  const { placeHolder, charLimit } = data;

  return (
    <SectionContent hasBottomBorder>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                rightPart={
                  <CountWords
                    count={(placeHolder || '').length}
                    allCount={200}
                  />
                }
                bottomTitle={getI18n(
                  'allProducts.addvirtualproduct.productdetail_component_fieldpart_contentmessage_bottomTitle',
                )}
                title={getI18n(
                  'allProducts.addvirtualproduct.productdetail_component_fieldpart_contentmessage_title',
                )}>
                <TextArea
                  autoSize={{ minRows: 1, maxRows: 3 }}
                  value={placeHolder}
                  onChange={onPlaceholderChange}
                  maxLength={200}
                  disabled={disabled}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper
                containerClassName={css.containerClassName}
                bottomTitle={getI18n(
                  'allProducts.addvirtualproduct.productdetail_component_fieldpart_characters_bottomTitle',
                )}
                title={getI18n(
                  'allProducts.addvirtualproduct.contentCharacterlettersLimitation',
                )}>
                <div className={css.numberInputContainer}>
                  <NumberInput
                    wrapperClassName={css.numberInput}
                    size='large'
                    max={9999}
                    min={0}
                    onChange={onCharLimitChange}
                    value={charLimit}
                    disabled={disabled}
                  />
                  <div className={css.numberInputTip}>0-9999</div>
                </div>
              </ItemWrapper>
            ),
          },
        ]}
      />
    </SectionContent>
  );
};
export default Field;
